exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".input-palavra[_v-ace4b018]{width:58.5%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-ace4b018&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/filtros/filtro1/filtro.vue
// module id = 182
// module chunks = 0